<template>
    <sa-page-layout :showModalLoading="showModalLoading" class="sa-no-space" btnRefreshVisible @refresh="refresh">
        <template slot="toolbar">
            <b-button variant="outline-primary btn-toolbar float-sm-right sa-margin-right" class="btn-toolbar float-sm-right sa-margin-right position-relative" @click="goToNotifiche()">
                <b-icon icon="bell" class="mr-1" /> Notifiche

                <b-badge variant="danger" pill class="position-absolute" style="top: -5px; right: -5px">
                    {{ notificheNumber }}
                </b-badge>
            </b-button>
        </template>
        <template slot="table-filter">
            <b-form style="width: 100%" @submit.prevent="submit">
                <div class="sa-form-section sa-search-box m-2">
                    <b-row style="margin-left: 0.5rem; margin-right: 0.5rem" class="sa-form-btn-filter">
                        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                            <label class="sa-label-data">Codice Pratica</label>
                            <input class="sa-search-box-input text-upper" type="search" v-model="filter.codice" />
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                            <label class="sa-label-data">Cognome Assistito</label>
                            <input class="sa-search-box-input text-upper" type="search" v-model="filter.cognomeAssistito" />
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                            <label class="sa-label-data">Nome Assistito</label>
                            <input class="sa-search-box-input text-upper" type="search" v-model="filter.nomeAssistito" />
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                            <label class="sa-label-data">Stato Pratica</label>
                            <b-form-select v-model="filter.stato" class="sa-ft-form-select">
                                <b-form-select-option :value="null"> TUTTI </b-form-select-option>
                                <b-form-select-option v-for="(stato, i) in statiOptions" :key="i" :value="stato">
                                    {{ stato }}
                                </b-form-select-option>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                            <label class="sa-label-data">Stato Visualizzazione</label>
                            <b-form-select v-model="filter.statoVisualizzazione" class="sa-ft-form-select">
                                <b-form-select-option :value="null"> TUTTI </b-form-select-option>
                                <b-form-select-option value="DA VISUALIZZARE"> DA VISUALIZZARE </b-form-select-option>
                                <b-form-select-option value="VISUALIZZATA"> VISUALIZZATA </b-form-select-option>
                            </b-form-select>
                        </b-col>
                        <!-- <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
							<div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
								<label class="sa-search-box-label">Data Riferimento Prenotazione</label>
							
							</div>
						</b-col> -->
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="padding: 8px; gap: 10px; display: flex; justify-content: end">
                            <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                            <b-button type="button" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-form>
        </template>
        <template slot="table-body">
            <SiatPraticheListComponent @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" ref="cmpSiatPraticheListComponent" />
        </template>
    </sa-page-layout>
</template>

<script>
import toast from "../../../template/layout/utility/sa-toast.js";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin.js";
import SiatPraticheListComponent from "../components/SiatPraticheListComponent.vue";
export default {
    components: { SaPageLayout, SiatPraticheListComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            statiOptions: ["APERTA"],
            showModalLoading: false,
            filter: {
                assistitoCognome: null,
                prIdSiat: null,
                stato: "APERTA",
                statoVisualizzazione: "DA VISUALIZZARE",
            },
            notificheNumber: 0,
        };
    },
    mounted() {
        let sessionStorage = window.sessionStorage;
        this.filter = {
            forPage: this.perPage,
            page: this.currentPage,
            stato: "APERTA",
            statoVisualizzazione: "DA VISUALIZZARE",
        };
        if (sessionStorage["filtroSiatPratiche"]) {
            let filtro = JSON.parse(sessionStorage["filtroSiatPratiche"]);
            this.filter = { ...this.filter, ...filtro };
            sessionStorage["filtroSiatPratiche"] = JSON.stringify(this.filter);
        }
        this.loadData();
    },

    methods: {
        loadData() {
            this.loadDataNotifiche();
            this.$refs.cmpSiatPraticheListComponent.loadData();
        },
        refresh() {
            this.loadData();
        },
        onReset() {
            this.filter = {
                assistitoCognome: null,
                assistitoNome: null,
                prIdSiat: null,
                stato: "APERTA",
                statoVisualizzazione: "DA VISUALIZZARE",
            };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroSiatPratiche"] = JSON.stringify(this.filter);
            this.loadData();
        },
        goToNotifiche() {
            this.$router.push("/notifichesiat");
        },
        submit() {
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroSiatPratiche"] = JSON.stringify(this.filter);
            this.loadData();
        },
        onClickNotifica() {
            console.log("notifica ");
        },
        loadDataNotifiche() {
            this.loadDataResources("/siatpratichescelte/notifiche", {}, this.loadDataNotificheSuccess, this.loadDataNotificheError);
        },
        loadDataNotificheSuccess(response) {
            let intNumber = response.data.data;
            this.notificheNumber = intNumber;
        },
        loadDataNotificheError() {
            toast.error("Errore durante il recupero delle notifiche!");
        },
        onBeforeLoadData() {},
        onAfterLoadData() {},
    },
};
</script>
